/**
 * i18n управления агентами (DEV-437, фаза 2 DEV-332).
 *
 * Подмешивается в основные локали через deep-merge в ./index.ts (как
 * routingOnboarding / agentTickets). Блок agentsAdmin.* + пункт
 * common.navigation.agentsAdmin (deep-merge сливает common.navigation вглубь).
 * Без литеральных фигурных скобок (vue-i18n).
 */

type LocaleOverride = Record<string, unknown>

export const agentsAdminMessages: Record<'ru' | 'en' | 'vn', LocaleOverride> = {
  ru: {
    common: { navigation: { agentsAdmin: 'Агенты' } },
    agentsAdmin: {
      title: 'Управление агентами',
      subtitle: 'Список агентов и назначение куратора',
      filters: {
        search: 'Поиск',
        searchPlaceholder: 'ФИО, агентство, контакт…',
        curator: 'Куратор',
        allCurators: 'Все',
        apply: 'Применить',
        reset: 'Сбросить',
      },
      columns: {
        fullName: 'ФИО',
        agency: 'Агентство',
        contact: 'Контакт',
        location: 'Локация',
        curator: 'Куратор',
      },
      actions: {
        assign: 'Назначить менеджера',
        take: 'Взять агента',
      },
      empty: {
        title: 'Агентов нет',
        description: 'Агенты по выбранным фильтрам появятся здесь.',
      },
      assign: {
        title: 'Назначить куратора',
        manager: 'Куратор (менеджер)',
        placeholder: 'Выберите менеджера',
        unassign: '— Снять куратора —',
        cancel: 'Отмена',
        confirm: 'Сохранить',
      },
      toast: {
        assigned: 'Куратор назначен',
        taken: 'Вы стали куратором агента',
        actionError: 'Не удалось выполнить действие',
      },
    },
  },
  en: {
    common: { navigation: { agentsAdmin: 'Agents' } },
    agentsAdmin: {
      title: 'Agent management',
      subtitle: 'Agent list and curator assignment',
      filters: {
        search: 'Search',
        searchPlaceholder: 'Name, agency, contact…',
        curator: 'Curator',
        allCurators: 'All',
        apply: 'Apply',
        reset: 'Reset',
      },
      columns: {
        fullName: 'Full name',
        agency: 'Agency',
        contact: 'Contact',
        location: 'Location',
        curator: 'Curator',
      },
      actions: {
        assign: 'Assign manager',
        take: 'Take agent',
      },
      empty: {
        title: 'No agents',
        description: 'Agents matching the selected filters will appear here.',
      },
      assign: {
        title: 'Assign curator',
        manager: 'Curator (manager)',
        placeholder: 'Select a manager',
        unassign: '— Unassign curator —',
        cancel: 'Cancel',
        confirm: 'Save',
      },
      toast: {
        assigned: 'Curator assigned',
        taken: 'You became the agent curator',
        actionError: 'Could not perform the action',
      },
    },
  },
  vn: {
    common: { navigation: { agentsAdmin: 'Đại lý' } },
    agentsAdmin: {
      title: 'Quản lý đại lý',
      subtitle: 'Danh sách đại lý và phân công người phụ trách',
      filters: {
        search: 'Tìm kiếm',
        searchPlaceholder: 'Họ tên, công ty, liên hệ…',
        curator: 'Người phụ trách',
        allCurators: 'Tất cả',
        apply: 'Áp dụng',
        reset: 'Đặt lại',
      },
      columns: {
        fullName: 'Họ tên',
        agency: 'Công ty',
        contact: 'Liên hệ',
        location: 'Khu vực',
        curator: 'Người phụ trách',
      },
      actions: {
        assign: 'Phân công quản lý',
        take: 'Nhận đại lý',
      },
      empty: {
        title: 'Chưa có đại lý',
        description: 'Đại lý theo bộ lọc đã chọn sẽ hiển thị ở đây.',
      },
      assign: {
        title: 'Phân công người phụ trách',
        manager: 'Người phụ trách (quản lý)',
        placeholder: 'Chọn quản lý',
        unassign: '— Bỏ người phụ trách —',
        cancel: 'Hủy',
        confirm: 'Lưu',
      },
      toast: {
        assigned: 'Đã phân công người phụ trách',
        taken: 'Bạn đã trở thành người phụ trách đại lý',
        actionError: 'Không thể thực hiện hành động',
      },
    },
  },
}
